import { render, staticRenderFns } from "./bodyLeftBottom.vue?vue&type=template&id=21782184&scoped=true"
import script from "./bodyLeftBottom.vue?vue&type=script&lang=js"
export * from "./bodyLeftBottom.vue?vue&type=script&lang=js"
import style0 from "./bodyLeftBottom.vue?vue&type=style&index=0&id=21782184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21782184",
  null
  
)

export default component.exports